// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-72d2a5fc] .p-sortable-column-icon{margin:0 0 0 0!important}button[data-v-72d2a5fc]{margin:0 2px}.pendente[data-v-72d2a5fc]{color:#1f2d3d;background-color:#ffc107;font-weight:700}.ativa[data-v-72d2a5fc]{background-color:#007bff}.ativa[data-v-72d2a5fc],.cancelada[data-v-72d2a5fc]{color:#fff;font-weight:700}.cancelada[data-v-72d2a5fc]{background-color:#dc3545}.quitada[data-v-72d2a5fc]{color:#fff;background-color:#28a745;font-weight:700}", ""]);
// Exports
module.exports = exports;
